import React, { useEffect, useState } from "react";
import DynamicTable from "@atlaskit/dynamic-table";
import styles from "../../pages/JobDetails/Jobdetails.module.css";
import { createHead, createCells } from "./restoreIssuesTableHandler";
const TableWrapper = ({ children }) => (
  <div className={styles.restoreissuesjobdetailstablewrapper}>{children}</div>
);

const RestoreIssuesJobDetails = ({
  isLoading,
  restoreIssuesDetails,
  refresh,
  jobType,
}) => {
  const [base_url, setBaseUrl] = useState("");

  const rows = createCells(
    restoreIssuesDetails ? restoreIssuesDetails : [],
    base_url,
    isLoading,
    jobType
  );
  const head = createHead(false, jobType);
  useEffect(() => {
    const getUserDetails = async () => {
      //eslint-disable-next-line
      await AP.user.getCurrentUser(function (user) {
        let accountId = user.atlassianAccountId;
        //eslint-disable-next-line
        AP.request(`/rest/api/3/user?accountId=${accountId}`, {
          success: function (responseText) {
            const data = JSON.parse(responseText);
            setBaseUrl(data.self.split("/rest")[0]);
          },
        });
      });
    };
    //eslint-disable-next-line
    AP.context.getToken(function (token) {
      getUserDetails();
    });
  }, [refresh]);
  return (
    <TableWrapper>
      <DynamicTable
        head={head}
        rows={rows}
        rowsPerPage={undefined}
        defaultPage={1}
        loadingSpinnerSize="large"
        isLoading={isLoading}
        emptyView={<strong>No data found</strong>}
      />
    </TableWrapper>
  );
};

export default RestoreIssuesJobDetails;
